import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import apiClient from "../services/apiClient";
import { clearUser } from "../features/auth/authSlice";


const PrivateRoute = () => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(true); 
  
  useEffect(() => {
    const checkLogin = async () => {
      try {
        const response = await apiClient.get("/login-check");
        if (response?.data?.status === "success") {
           // update Redux state if needed
        } else {
          dispatch(clearUser());
        }
      } catch (error) {
        dispatch(clearUser());
      } finally {
        setLoading(false);
      }
    };

    checkLogin();
  }, [dispatch]);

  

  if (!isAuthenticated) {
    return <Navigate to="/auth/login" replace />;
  }

  return <Outlet />; 
};

export default PrivateRoute;
